import React from 'react';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import {
  Container,
  Title,
  Dek,
  Br,
  Message,
  StyledBulletedList,
} from './WebsiteDesignPdpIntro.styles';

export type WebsiteDesignPdpIntroProps = {
  className?: string;
  onCtaClick: () => void;
};

const WebsiteDesignPdpIntro = ({
  className,
  onCtaClick,
}: WebsiteDesignPdpIntroProps): JSX.Element => (
  <Container className={className}>
    <Title>Create a free, Beautiful Wedding Website</Title>
    <Dek className="preauth-intro-sub-header">
      Every custom website feature you could want or need, right here.
    </Dek>

    <StyledBulletedList>
      <Message>Password protect your website.</Message>
      <Message>Purchase a custom website domain name from Zola.</Message>
      <Message>
        Integrate your Zola registry or <Br /> link to one from another store.
      </Message>
      <Message>
        Collect RSVPs, ask for meal <Br />
        preferences, and more.
      </Message>
    </StyledBulletedList>
    <ButtonV3 onClick={onCtaClick}>Get started</ButtonV3>
  </Container>
);

export default WebsiteDesignPdpIntro;
